import { match } from 'components/common/form/formValidationRules';
import { fiftyCharactersMax } from 'helpers/regex';

const MY = {
  serviceObjects: {
    autoComplete: false,
  },
  market: 'MY',
  enrollment: {
    form: {
      sections: {
        my_legal: {
          fields: [
            'MALDistributor',
            'CompanyRegistrationNumber',
            'IndustriesCode',
            'PassportNumber',
            'IdentityCardNumber',
            'TIN',
            // 'IdentityCardName',
          ],
          order: 4,
          localeEntry: 8,
        },
      },
    },
  },
  inputs: {
    fields: ['ADDRESS1', 'ADDRESS2', 'ZIP', 'CITY', 'STATE'],
    ADDRESS2: {
      validationChecks: [match(fiftyCharactersMax, 'validation-max-50')],
    },
    ZIP: {
      required: false,
      labelRef: 'POSTAL_CODE',
    },
    STATE: {
      type: 'dropdown',
    },
    MALDistributor: {
      labelRef: 'CITIZENSHIP_MY',
      required: true,
    },
    CompanyRegistrationNumber: {
      labelRef: 'COMPANY_REGISTRATION_NUMBER_MY',
      required: true,
    },
    IndustriesCode: {
      labelRef: 'INDUSTRIES_CODE_MY',
      required: true,
    },
    PassportNumber: {
      labelRef: 'PASSPORT_NUMBER_MY',
      required: true,
    },
    IdentityCardNumber: {
      labelRef: 'IDENTITY_CARD_NUMBER_MY',
      required: true,
    },
    TIN: {
      labelRef: 'TIN_MY',
      required: true,
    },
  },
};
export default MY;
